import type {ActionButtons} from "./checkDepositPermissions"
import {CheckDepositStatus, CheckDepositVendors} from "../../resources/checkDeposits"

export const waitingForOcrLabel = "Waiting for OCR results"
export const disabledActionsEnsentaTooltipValue = "Cannot perform actions for this vendor"

export const getCheckActionsTitle = ({
	waitingForOcr = false,
	vendor,
	isOrgAdmin,
	isUnitUser,
}: {
	waitingForOcr?: boolean
	vendor: CheckDepositVendors | undefined
	isOrgAdmin: boolean
	isUnitUser: boolean
}): string => {
	if (waitingForOcr) {
		return waitingForOcrLabel
	}
	if (vendor === CheckDepositVendors.Ensenta && !isOrgAdmin && !isUnitUser) {
		return disabledActionsEnsentaTooltipValue
	}
	return ""
}

export const getButtonsToShow = (
	status: keyof typeof CheckDepositStatus,
	vendor: CheckDepositVendors | undefined,
	waitingForOcr = false
): ActionButtons => {
	const isVeryfi = vendor === CheckDepositVendors.Veryfi
	if (status === CheckDepositStatus.Canceled || status === CheckDepositStatus.Rejected) {
		return null
	}
	switch (status) {
		case CheckDepositStatus.PendingReview:
			// While waiting for OCR results the check has no decision data yet, so approve/reject is not allowed.
			if (waitingForOcr) {
				return isVeryfi ? ["Cancel"] : null
			}
			return isVeryfi ? ["Cancel"] : ["Approve", "Reject"]
		case CheckDepositStatus.Pending:
			return isVeryfi ? ["Cancel"] : null
		case CheckDepositStatus.AwaitingImages:
		case CheckDepositStatus.AwaitingFrontImage:
		case CheckDepositStatus.AwaitingBackImage:
			return isVeryfi ? ["Cancel"] : null
		case CheckDepositStatus.Clearing:
			return ["Return", "Clear"]
		case CheckDepositStatus.Sent:
			return ["Return"]
		default:
			return null
	}
}
